import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TypeComponentFieldEnum } from '../../../../../domain/registration/enums/type-component-dynamic.enum';
import { IFieldConfig } from '../../../../../domain/IFieldConfig';

@Component({
  selector: 'app-filter-crud-index',
  templateUrl: './filter-crud-index.component.html',
  styleUrls: ['./filter-crud-index.component.sass'],
})
export class FilterCrudIndexComponent implements OnInit, OnChanges {
  @Input()
  filterFields: IFieldConfig[];

  @Input()
  initialValues: any = null;

  @Output()
  onFilter: EventEmitter<any> = new EventEmitter();

  @Output()
  onResetFilter: EventEmitter<any> = new EventEmitter();

  formGroup: FormGroup;

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Se filterFields mudar, reconstruímos o formulário
    if (changes['filterFields']) {
      this.initializeForm();
    }
  }

  filter() {
    this.onFilter.emit(this.formGroup);
  }

  // Método para inicialização normal (usa initialValues)
  initializeForm() {
    // Recriamos o formulário do zero
    this.formGroup = this.fb.group({});

    if (this.filterFields) {
      this.filterFields.forEach((f) => {
        const initialValue = this.initialValues && this.initialValues[f.name] !== undefined ?
          this.initialValues[f.name] :
          null;

        switch (f.type) {
          case TypeComponentFieldEnum.SLIDE_TOGGLE:
            let toggleValue = false;

            if (initialValue !== null) {
              toggleValue = !!initialValue;
            } else if (f.name === 'isActive') {
              toggleValue = f.value !== undefined ? !!f.value : true;
            } else {
              toggleValue = f.value !== undefined ? !!f.value : false;
            }

            this.formGroup.addControl(f.name, this.fb.control(toggleValue));
            break;
          case TypeComponentFieldEnum.SELECT:
          case TypeComponentFieldEnum.SELECT_CRUD:
            const selectValue = initialValue !== null ? initialValue : (f.value || '');
            this.formGroup.addControl(f.name, this.fb.control(selectValue));
            break;
          case TypeComponentFieldEnum.INPUT_DATE:
          case TypeComponentFieldEnum.INPUT_DATETIME:
            const dateValue = initialValue !== null ? initialValue : (f.value || null);
            this.formGroup.addControl(f.name, this.fb.control(dateValue));
            break;
          default:
            const defaultValue = initialValue !== null ? initialValue : (f.value || '');
            this.formGroup.addControl(f.name, this.fb.control(defaultValue));
        }
      });
    }
  }

  // Método para reset (sempre limpa os campos)
  resetFilter() {
    // Recriamos o formulário do zero
    this.formGroup = this.fb.group({});

    if (this.filterFields) {
      this.filterFields.forEach((f) => {
        // Para reset, sempre usar valores padrão limpos
        switch (f.type) {
          case TypeComponentFieldEnum.SLIDE_TOGGLE:
            // Para toggles, usar false como padrão, exceto isActive que deve ser true
            const toggleValue = f.name === 'isActive' ? true : false;
            this.formGroup.addControl(f.name, this.fb.control(toggleValue));
            break;
          case TypeComponentFieldEnum.SELECT:
          case TypeComponentFieldEnum.SELECT_CRUD:
            // Para selects, usar string vazia como padrão
            this.formGroup.addControl(f.name, this.fb.control(''));
            break;
          case TypeComponentFieldEnum.INPUT_DATE:
          case TypeComponentFieldEnum.INPUT_DATETIME:
            // Para datas, usar null como padrão
            this.formGroup.addControl(f.name, this.fb.control(null));
            break;
          default:
            // Para outros campos, usar string vazia como padrão
            this.formGroup.addControl(f.name, this.fb.control(''));
        }
      });
    }
  }

  onClickResetFilter() {
    // Limpar o formulário visual
    this.resetFilter();
    // Emitir evento para o componente pai
    this.onResetFilter.emit();
  }

  public getFieldConfig(name: string): any {
    return this.filterFields.find((c) => c.name === name);
  }
}
